import { useEffect } from 'react';

/**
 * Calls `handler` when a `mousedown` happens outside the element referenced by `ref`.
 * Encapsulates the listener lifecycle so consumers don't need to manage deps manually.
 *
 * @param {React.RefObject<HTMLElement>} ref
 * @param {(event: MouseEvent) => void} handler
 */
export function useClickOutside(ref, handler) {
  useEffect(() => {
    const onMouseDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler(event);
      }
    };
    document.addEventListener('mousedown', onMouseDown);
    return () => document.removeEventListener('mousedown', onMouseDown);
  }, [ref, handler]);
}
